module.exports = __webpack_public_path__ + "static/media/2-item-a.e131509d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/2-item-a.jpg
// module id = 1157
// module chunks = 33